<template>
    <!--  <transition name="fade">-->
    <div class="form-entry row row-cols-1" v-if="formResponse">

        <span class="text-error">{{errorMessage}}</span>

        <div class="col title-navigation">
            <h1 class="text-left">
                <template v-if="isFormEditable">Edit</template>
                <template v-else>View</template>
                Form</h1>

            <button class="hover-button" v-on:click.stop="openBooking()">
                <i class="fas fa-bed"></i>
            </button>
            <button class="hover-button" v-on:click.stop="openTask()">
                <i class="far fa-calendar-alt"></i>
            </button>
        </div>

        <div class="col">
            <div class="card summary">
                <div class="card-header">
                    <div class="media-body">
                        <h5 class="card-title">{{formResponse.title}}</h5>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col col-4">Booked by</div>
                        <div class="col-8">{{formResponse.booking.bookedBy.firstName}}
                            {{formResponse.booking.bookedBy.lastName}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">Arrival</div>
                        <div class="col-8">{{friendlyDateFull(formResponse.booking.arrival)}}</div>
                    </div>
                    <div class="row">
                        <div class="col-4">Departure</div>
                        <div class="col-8">{{friendlyDateFull(formResponse.booking.departure)}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col">
            <ValidationObserver ref="responseForm" v-slot="{ invalid }">
                <form v-on:submit.prevent="onSubmit">
                    <FormSection v-for="(section, index) in formResponse.sections"
                                 v-bind:section="section"
                                 v-bind:guestReference="formResponse.booking.bookedBy.reference"
                                 v-bind:responseReference="formResponse.reference"
                                 v-bind:section-number="index"
                                 v-bind:key="section.reference"
                                 v-bind:answerCache="answerCache"
                                 v-bind:completed="formResponse.completed"></FormSection>

                    <span v-if="invalid">
                        Note:
                        <ul>
                          <li>
                            Your <b>answers are saved</b> as you respond, but the form is incomplete.
                          </li>
                          <li>
                            Please fill in the <span
                                  v-bind:class="{'text-error' : formValidationFailed}">missing fields</span>
                            <template v-if="isArrivalToday">
                              now, as arrival is today
                            </template>
                            <template v-else>
                              ASAP to Submit this form.
                            </template>
                          </li>
                        </ul>
                    </span>

                    <div v-if="updating || success || error" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>
                    <div v-show="updating && !success">
                        <Spinner/>
                    </div>

                    <template v-if="isFormEditable">
                        <div v-show="!updating && !success" class="col text-center mb-2">
                            <router-link to="/forms" tag="button" class="btn btn-primary">Close</router-link>&nbsp;
                            <button type="submit" class="btn btn-secondary">Submit</button>
                        </div>
                    </template>

                    <div class="col mt-5 mr-1 ml-1 mb-5">
                        <span class="text-note">
                            POPIA Act compliance: Please note that any personal details provided here are stored securely and will only be
                            accessible to the establishment at which you have enquired or booked.
                        </span>
                    </div>

                </form>
            </ValidationObserver>
        </div>

    </div>
    <!--  </transition>-->
</template>

<script>
    // @ is an alias to /src
    import {store} from '../store.js'
    import {ValidationObserver} from 'vee-validate'

    import FormSection from '../components/forms/FormSection'
    import Spinner from '../components/Spinner.vue'
    import {datesMixin} from "../mixins/DatesMixin"

    import * as dayjs from 'dayjs'
    import isToday from 'dayjs/plugin/isToday'

    dayjs.extend(isToday);

    export default {
        name: 'OpenForm',
        components: {FormSection, ValidationObserver, Spinner},
        mixins: [datesMixin],
        props: {},
        data: function () {
            return {
                formResponse: null,
                answerCache: {},
                updating: false,
                error: false,
                success: false,
                infoMessage: null,
                formValidationFailed: false,
                errorMessage: ""
            }
        },
        computed: {
            isArrivalToday: function () {
                return dayjs(this.formResponse.booking.arrival).isToday();
            },
            isFormEditable: function () {
                if (this.formResponse && this.formResponse.editable) {
                    return true
                }
                return false
            }
        },
        methods: {
            loadForm: function() {
                const formReference = this.$route.params.reference;
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/form-responses/' + formReference).then(response => {
                    this.formResponse = response.data
                }).catch(error => {
                    console.log(error)
                })
            },
            reloadAnswer: function (reference) {
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference +
                               '/form-responses/' + this.formResponse.reference +
                               '/answers/' + reference).then(response => {
                    const updatedAnswer = response.data
                    this.answerUpdated(updatedAnswer)
                    this.$root.$emit('answer-reloaded', updatedAnswer)
                }).catch(error => {
                    console.log(error)
                    this.errorMessage = 'The form has been updated elsewhere, so we are reloading it for you'
                    setTimeout(() => {
                        this.loadForm()
                    }, 5000)
                })
            },
            answerUpdated: function (updatedAnswer) {
                for (const section of this.formResponse.sections) {
                    for (const answer of section.answers) {
                        if (answer.reference === updatedAnswer.reference) {
                            Object.assign(answer, updatedAnswer)
                        }
                    }
                }
            },
            openBooking: function() {
                console.log("opening booking");
                this.$root.$emit('open-trip-details', this.formResponse.booking);
            },
            openTask: function() {
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/bookings/' + this.formResponse.booking.reference, {
                    withCredentials: true
                }).then(response => {
                    if (response.data) {
                        let detailedBooking = response.data;
                        for (let task of detailedBooking.tasks) {
                            if (task.formResponseReference !== null && task.formResponseReference === this.formResponse.reference) {
                                this.$root.$emit('open-task-details', task);
                            }
                        }
                    }
                }).catch(error => {
                    console.log(error);
                    this.errorMessage = "There was an error loading the trip details";
                })
            },
            onSubmit: function () {
                this.$refs.responseForm.validate().then(success => {
                    if (!success) {
                        this.formValidationFailed = true

                        // find the first input that failed validation and scroll to it
                        const errors = Object.entries(this.$refs.responseForm.refs)
                            .map(([key, value]) => ({
                                key,
                                value
                            }))
                            .filter(error => {
                                if (!error || !error.value || !error.value.failedRules) return false
                                return Object.keys(error.value.failedRules).length > 0
                            })

                        if (errors && errors.length > 0) {
                            // find the parent section and make sure it's open
                            for (let i = 0; i < errors.length; i++) {
                                this.$refs.responseForm.refs[errors[i].key].$parent.$parent.openSection()
                            }
                            this.$refs.responseForm.refs[errors[0].key].$parent.$parent.openSection(() => {
                                const rect = this.$refs.responseForm.refs[errors[0].key].$el.getBoundingClientRect()
                                window.scrollTo(rect.x, window.pageYOffset + rect.top - 40)
                            })
                        }

                        return
                    }

                    this.formValidationFailed = false
                    this.updating = true;
                    this.infoMessage = "Submitting form";

                    this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference +
                        '/form-responses/' + this.formResponse.reference + '/completed-by-host').then(response => {
                        this.success = true;
                        this.updating = false;
                        this.formResponse = response.data
                        this.infoMessage = 'Form complete'
                    }).catch(error => {
                        this.error = true;
                        this.updating = false;
                        this.infoMessage = 'Sorry, but there was a problem marking your form as complete. ' +
                            'We have saved your data though. Please try refreshing the page.'
                        if (error.response) {
                            console.log(error.response.data)
                        }
                    })
                })
            }
        },
        mounted() {
            this.loadForm()
            this.$root.$on('response-form-updated', this.reloadForm);
            this.$root.$on('answer-updated', this.answerUpdated);
            this.$root.$on('reload-answer', this.reloadAnswer);
        },
        beforeDestroy () {
            this.$root.$off('answer-updated', this.answerUpdated);
            this.$root.$off('reload-answer', this.reloadAnswer);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/pages/view-form";
</style>
